import { Injectable } from '@angular/core';
import { BaseHubService } from './base-hub.service';
import { ILog } from '../../_models/Log';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../local/message.service';
import { ConfigService } from '../local/config.service';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../_store/mainStoreState';
import { setLogsAction } from '../../_store/LogsStore/logs.store';

@Injectable({
  providedIn: 'root',
})
export class LogService extends BaseHubService<ILog> {
  constructor(
    private store: Store<MainStoreState>,
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService
  ) {
    super('logs', 'hubs/logs', 'Logs', http, messageService, configService);
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: ILog[]): void {
    this.store.dispatch(setLogsAction({ payload: data }));
  }
}
